import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './context';
import type { Role } from '@/types/api';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used inside an AuthProvider');
  return context;
}

/** Convenience for the many places that branch on role. */
export function useRole(): Role | null {
  return useAuth().user?.role ?? null;
}

export function hasRole(role: Role | null, allowed: readonly Role[]): boolean {
  return role !== null && allowed.includes(role);
}
